/** @typedef {import('../../shared/AuthProvider/Roles').Roles} Roles */
/** @typedef {import('../../shared/AuthProvider/State').default} AuthState */
/** @typedef {Readonly<{ collapsible?: boolean, onListItemClick?: () => void }>} Props */
/** @typedef {Omit<import('../shared/NavigationListComponent').Props, 'location' | 'settings'>} NavigationListProps */

import { AuthContext } from '../../shared/AuthProvider';
import { getNavLinkList } from '../../config/local/navigation';
import { translate } from '../Internationalization';
import NavigationList from '../shared/NavigationList';
import React from 'react';
import RoleGate from '../shared/RoleGate';
import roles from '@mooveguru/yhh-shared-config/users/roles.json';

/** @extends {React.Component<Props>} */
export default class AdminNavigationList extends React.Component {
	/** @type {AuthState} */
	context = /** @type {AuthState} */ (/** @type {unknown} */ (null));

	/**
	 * @returns {string}
	 */
	determineHeading() {
		const role = this.getsRole();

		return translate(`global.forms.inputs.roles.${role ?? 'admin'}`);
	}

	/**
	 * @returns {Roles | undefined}
	 */
	getsRole() {
		const auth = this.context;
		const role = auth.roles.find((candidate) =>
			roles.admin.includes(candidate)
		);

		return role === undefined ? undefined : /** @type {Roles} */ (role);
	}

	render() {
		const auth = this.context;
		const role = this.getsRole();
		const navigationList = (
			<NavigationList
				collapsible={this.props.collapsible}
				heading={this.determineHeading()}
				links={getNavLinkList(role ?? 'admin', auth.isSubscribed)}
				onListItemClick={this.props.onListItemClick}
			/>
		);

		return <RoleGate allowedRoles={roles.admin}>{navigationList}</RoleGate>;
	}
}

AdminNavigationList.contextType = /** @type {React.Context<AuthState>} */ (
	AuthContext
);
